import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssetService from "../../Controller/AssetController"
import { handleChange, handleSubmit } from "../../Controller/UpdateWarrantyController";
import AssetNotificationService from "../../Controller/AssetNotificationController"
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CreateAssetNotification from "./CreateAssetNotification";
import SunTextEditor from "../../../Common/SunTextEditor";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";

function AssetNotes(AssetID) {
    AssetID = localStorage.getItem('AssetID');
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [formData, setFormData] = useState({
        dt_WarrantyStartDate: '',
        dt_WarrantyEndDate: '',
        snt_WarrantyPeriod: '',
        vc_WarrantyDescription: ''
    });
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const tableRef = useRef();
    const [AssetNotificationsList, setAssetNotification] = useState([]);
    const [NotificationTypeList, setNotificationType] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentAssetNotifications, setCurrentAssetNotification] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const fetchAssetWarrantyDetails = async () => {
        try {
            const data = await AssetService.GetAssetByID(redirectCallback, AssetID);

            const LastPurchaseDate = new Date(data[0].dt_LastPurchaseDate).toISOString().split('T')[0];
            const WarrantyStartDate = new Date(data[0].dt_WarrantyStartDate).toISOString().split('T')[0];
            const dt_WarrantyEndDate = new Date(data[0].dt_WarrantyEndDate).toISOString().split('T')[0];

            setFormData({
                dt_LastPurchaseDate: LastPurchaseDate,
                dt_WarrantyStartDate: WarrantyStartDate,
                dt_WarrantyEndDate: dt_WarrantyEndDate,
                snt_WarrantyPeriod: data[0].snt_WarrantyPeriod,
                vc_WarrantyDescription: data[0].vc_WarrantyDescription
            });
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const [loading, setLoading] = useState(true);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (NotificationTypeList.length > 0) {
            initDataTable();
        }
    }, [NotificationTypeList]);
    const fetchAssetNotifications = async () => {
        try {
            setAssetNotification([]);
            $(tableRef.current).DataTable().destroy();
            setLoading(true);
            const data = await AssetNotificationService.GetAllAssetNotification(redirectCallback, AssetID);
            setAssetNotification(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const fetchNotificationType = async () => {
        try {
            const data = await AssetNotificationService.GetNotificationType(redirectCallback);
            setNotificationType(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    const resetForm = () => {

        setFormData({
            dt_WarrantyStartDate: '',
            dt_WarrantyEndDate: '',
            snt_WarrantyPeriod: '',
            vc_WarrantyDescription: ''
        });
    };
    useEffect(() => {
        if (AssetID === 0) {
            setFormData({});
            resetForm();
        } else {
            fetchAssetWarrantyDetails();
            fetchAssetNotifications();
            fetchNotificationType();
        }
    }, [AssetID]);

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_WarrantyDescription: content
        });
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const handleFormSubmit = async (event) => {

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        formData.PK_Assets_ID = AssetID;
        const message = await handleSubmit(event, formData, setFormData, setErrors);
        if (message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
        fetchAssetWarrantyDetails();
    };

    const handleCreateAssetNotificationClick = () => {

        setCurrentAssetNotification(null);
        fetchNotificationType();
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {

        setIsModalOpen(false);
    };

    const handleEditClick = (history) => {

        setCurrentAssetNotification(history);
        fetchNotificationType();
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await AssetNotificationService.DeleteAssetNotification(redirectCallback, ID);
                    $(tableRef.current).DataTable().destroy();
                    fetchAssetNotifications();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };


    const handleSuccess = () => {

        fetchAssetNotifications(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };

    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3">
                <div className="col-sm-6">
                    <div className="col-sm-12">
                        <h6>Warranty Detail</h6>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="col-sm-12">
                        <h6>Email <span style={{ "float": "right" }}> </span></h6>

                    </div>

                </div>
            </div>
            <hr />
            <div className="row mb-3">

                <div className="col-sm-6">
                    <form onSubmit={handleFormSubmit}>
                        <div className="col-sm-12" style={{ marginTop: "15px" }}>

                            <div className="row mb-3">
                                <label htmlFor="dt_LastPurchaseDate" className="col-sm-3 col-form-label">Acquisition Date</label>
                                <div className="col-sm-9">
                                    <input type="date" className="form-control" name="dt_LastPurchaseDate" value={formData.dt_LastPurchaseDate} onChange={handleFieldChange} />
                                    {errors.dt_LastPurchaseDate && <div style={{ color: 'red' }}>{errors.dt_LastPurchaseDate}</div>}
                                </div>

                            </div>
                            <div className="row mb-3">
                                <label htmlFor="dt_WarrantyStartDate" className="col-sm-3 col-form-label">Start Date</label>
                                <div className="col-sm-9">
                                    <input type="date" className="form-control" name="dt_WarrantyStartDate" value={formData.dt_WarrantyStartDate} onChange={handleFieldChange} />
                                    {errors.dt_WarrantyStartDate && <div style={{ color: 'red' }}>{errors.dt_WarrantyStartDate}</div>}
                                </div>

                            </div>
                            <div className="row mb-3">
                                <label htmlFor="dt_WarrantyEndDate" className="col-sm-3 col-form-label">End Date</label>
                                <div className="col-sm-9">
                                    <input type="date" className="form-control" name="dt_WarrantyEndDate" value={formData.dt_WarrantyEndDate} onChange={handleFieldChange} />
                                    {errors.dt_WarrantyEndDate && <div style={{ color: 'red' }}>{errors.dt_WarrantyEndDate}</div>}
                                </div>

                            </div>
                            <div className="row mb-3">
                                <label htmlFor="vc_WarrantyDescription" className="col-sm-3 col-form-label">Description:<span style={{ "color": "red" }}>*</span></label>
                                <div className="col-sm-9">
                                    <SunTextEditor
                                        value={formData.vc_WarrantyDescription}
                                        onChange={(content) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                vc_WarrantyDescription: content,
                                            }))
                                        }
                                    />
                                    {errors.vc_WarrantyDescription && <div style={{ color: 'red' }}>{errors.vc_WarrantyDescription}</div>}
                                </div>

                            </div>
                            <div className="row" style={{ "marginLeft": "0px", "float": "right" }}>
                                <div className="col-sm-4">
                                    <button type="submit" className={`btn btn-primary ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                       <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  Save
                                    </button>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-sm-6">
                    <div className="col-sm-12" >


                        <div className="row mb-3">
                            <div className="col-xl-12">
                                <div className="card mb-30">
                                    <div className="card-body">


                                        <div className="table-responsive">
                                            <button className={`btn btn-primary ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateAssetNotificationClick}>
                                                <i className="icofont-plus" aria-hidden="true"> Add New</i>
                                            </button>
                                            <table className="table m-0 table-hover" ref={tableRef}>
                                                <thead>
                                                    <tr>
                                                        <th>Email</th>
                                                        <th>Notification Date</th>
                                                        <th>Frequency</th>
                                                        <th style={{ "textAlign": "right" }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {AssetNotificationsList.map((email) => (

                                                        <tr key={email.PK_AssetNotifications_ID} onClick={() => handleEditClick(email)} style={{ cursor: 'pointer' }}>
                                                            <td>{email.vc_Email}</td>
                                                            <td>{formatDate(email.dt_LastFrequencyCheck)}</td>

                                                            <td>{email.Frequency}</td>

                                                            <td className="rightColumn">

                                                                <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, email.PK_AssetNotifications_ID)}>
                                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isModalOpen && (
                        <CreateAssetNotification
                            modalInstance={modalInstance}
                            currentAssetNotifications={currentAssetNotifications}
                            onClose={handleCloseModal}
                            onSuccess={handleSuccess}
                            NotificationTypeList={NotificationTypeList}
                            AssetID={AssetID}
                        />
                    )}
                </div>
            </div>

        </div>
    );
}
export default AssetNotes;